import { render, staticRenderFns } from "./CheckBoxLabelListItem.vue?vue&type=template&id=0f8c9776&scoped=true"
import script from "./CheckBoxLabelListItem.vue?vue&type=script&lang=js"
export * from "./CheckBoxLabelListItem.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxLabelListItem.vue?vue&type=style&index=0&id=0f8c9776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c9776",
  null
  
)

export default component.exports